export const datePick = {
    lang: {
        days: ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
        months:["Січ", "Лют", "Бер", "Кві", "Тра", "Чер", "Лип", "Сер", "Вер", "Жов", "Лис", "Гру"],
        pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
        placeholder: {
            date: 'Оберіть дату',
            dateRange: 'Оберіть інтервал дат'
        }
    },
};
